
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kGWTg", function(module, exports) {
$parcel$export(module.exports, "default", () => $2acaac22bee87da3$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

/* DecisionItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1cfRh = parcelRequire("1cfRh");


var $ejBUP = parcelRequire("ejBUP");


var $1oCLl = parcelRequire("1oCLl");


var $gA5pn = parcelRequire("gA5pn");


var $fRWmC = parcelRequire("fRWmC");

const $bf7c9494649d42d4$var$iconStyles = null;
const $bf7c9494649d42d4$var$iconStylesWithPlaceholder = null;
const $bf7c9494649d42d4$var$DecisionItem = ({ appearance: appearance, children: children, contentRef: contentRef, placeholder: placeholder, showPlaceholder: showPlaceholder, dataAttributes: dataAttributes })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const icon = /*#__PURE__*/ (0, $l998X.jsx)("span", {
        contentEditable: false,
        className: (0, $gMc0m.default)([
            "_16jlidpf _1o9zidpf _i0dlexct _4t3i7vkz _1bsb7vkz _19pk1b66 _2hwxutpp _otyridpf _18u0idpf _syaz4pcx _1e0c1txw _4cvr1h6o _1bah1h6o",
            showPlaceholder && "_syazdgkc"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ejBUP))), {
            label: (0, $1oCLl.expValEquals)('editor_a11y_decision_aria_label', 'isEnabled', true) ? showPlaceholder && children === undefined ? formatMessage((0, $fRWmC.messages).undefinedDecisionAriaLabel) : formatMessage((0, $fRWmC.messages).decisionAriaLabel) : 'Decision',
            spacing: "spacious",
            color: "currentColor"
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gA5pn.default), {
        appearance: appearance,
        contentRef: contentRef,
        icon: icon,
        placeholder: placeholder,
        showPlaceholder: showPlaceholder,
        itemType: "DECISION",
        dataAttributes: dataAttributes,
        children: children
    });
};
var $bf7c9494649d42d4$export$2e2bcd8739ae039 = $bf7c9494649d42d4$var$DecisionItem;


function $2acaac22bee87da3$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bf7c9494649d42d4$export$2e2bcd8739ae039), {
        dataAttributes: dataAttributes,
        children: children
    });
}

});

parcelRegister("gA5pn", function(module, exports) {
/* Item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

function $df30472fd50f26c9$var$_defineProperty(e, r, t) {
    return (r = $df30472fd50f26c9$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $df30472fd50f26c9$var$_toPropertyKey(t) {
    var i = $df30472fd50f26c9$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $df30472fd50f26c9$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $df30472fd50f26c9$var$placeholderStyles = null;
const $df30472fd50f26c9$var$placeholderTaskStyles = null;
const $df30472fd50f26c9$var$decisionStyles = null;
const $df30472fd50f26c9$var$contentStyles = null;
const $df30472fd50f26c9$var$taskStyles = null;
class $df30472fd50f26c9$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    renderPlaceholder() {
        const { children: children, placeholder: placeholder, showPlaceholder: showPlaceholder, itemType: itemType } = this.props;
        if (!showPlaceholder || !placeholder || children) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)("span", {
            "data-testid": "task-decision-item-placeholder",
            "data-component": "placeholder",
            contentEditable: false,
            className: (0, $gMc0m.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0tu8f _1reo15vq _18m915vq _kqswstnw _syaz1rpy _lcxvglyw _1bto1l2s _o5721q9c _p12f1dza",
                itemType === 'TASK' && "_19pkidpf _2hwxidpf _otyridpf _18u0hwpb"
            ]),
            children: placeholder
        });
    }
    renderMessageAppearance() {
        const { contentRef: contentRef, children: children, icon: icon, itemType: itemType, checkBoxId: checkBoxId, dataAttributes: dataAttributes } = this.props;
        if (itemType === 'TASK') return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
            id: `${checkBoxId}-wrapper`,
            className: (0, $gMc0m.default)([
                "_1e0c1txw _2lx2vrvc _kqswh2mm"
            ]),
            children: [
                icon,
                this.renderPlaceholder(),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    "data-component": "content",
                    ref: contentRef,
                    ...dataAttributes,
                    className: (0, $gMc0m.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1wug _slp31hna _1ul9idpf"
                    ]),
                    children: children
                })
            ]
        });
        else if (itemType === 'DECISION') return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
            "data-testid": "elements-decision-item",
            "data-decision-wrapper": "true",
            className: (0, $gMc0m.default)([
                "_2rkofajl _1e0c1txw _2lx2vrvc _19pku2gc _2hwxidpf _otyridpf _18u0idpf _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvutpp _bfhki8nm _kqswh2mm _14hd1wug"
            ]),
            children: [
                icon,
                this.renderPlaceholder(),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    "data-component": "content",
                    ref: contentRef,
                    ...dataAttributes,
                    className: (0, $gMc0m.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1wug _slp31hna _1ul9idpf"
                    ]),
                    children: children
                })
            ]
        });
        return null;
    }
    render() {
        return this.renderMessageAppearance();
    }
}
$df30472fd50f26c9$var$_defineProperty($df30472fd50f26c9$export$2e2bcd8739ae039, "defaultProps", {
    appearance: 'inline'
});
module.exports["default"] = $df30472fd50f26c9$export$2e2bcd8739ae039;

});

parcelRegister("fRWmC", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $01fdfd6ac0ede0b3$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    fieldsetLabel: {
        id: "fabric.editor.fieldsetLabel",
        defaultMessage: "Action Item List"
    },
    markTaskAsCompleted: {
        id: "platform.taskDecision.markTaskAsCompleted",
        defaultMessage: "Mark task as completed"
    },
    markTaskAsNotCompleted: {
        id: "platform.taskDecision.markTaskAsNotCompleted",
        defaultMessage: "Mark task as not completed"
    },
    decisionAriaLabel: {
        id: "platform.taskDecision.decisionAriaLabel",
        defaultMessage: "Decision"
    },
    undefinedDecisionAriaLabel: {
        id: "platform.taskDecision.undefinedDecisionAriaLabel",
        defaultMessage: "Undefined decision"
    }
});
module.exports["messages"] = $01fdfd6ac0ede0b3$export$defe85febe8b728c;

});


//# sourceMappingURL=decisionItem.c7ec37fd.js.map
